import { BlogComposer } from './blog';

// TODO: Maybe variable names need to qualified
// to be 'composer'.. don't know yet.

// NOTE(t10u): Add new modules here as created.
const coreModuleComposers = [
  BlogComposer,
];

const coreModuleComposerRegistry = coreModuleComposers.reduce((registry, Component) => {
  registry[Component.moduleId] = Component;
  return registry;
}, {});


export const findModuleComposer = (moduleId) => {
  return coreModuleComposerRegistry[moduleId];

  // TODO(t10u): For now only deal with the latest
  // version of core modules. But in the future,
  // think about how to handle:
  // + supporting older versions
  // + supporting third party modules
};


export { default as CoreModulePickerRibbon } from './CoreModulePickerRibbon';



// WEBPACK FOOTER //
// ./src/components/modules/index.js